import _toConsumableArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import crypto, { isCryptoKey } from './webcrypto.js';
import { checkSigCryptoKey } from '../lib/crypto_key.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { types } from './is_key_like.js';
export default function getCryptoKey(alg, key, usage) {
  if (isCryptoKey(key)) {
    checkSigCryptoKey(key, alg, usage);
    return key;
  }
  if (key instanceof Uint8Array) {
    if (!alg.startsWith('HS')) {
      throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));
    }
    return crypto.subtle.importKey('raw', key, {
      hash: "SHA-".concat(alg.slice(-3)),
      name: 'HMAC'
    }, false, [usage]);
  }
  throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types), ['Uint8Array'])));
}